import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { UniqueTimeBlockData } from 'modules/attendance/store/models/UniqueTimeBlockData'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import CheckBoxItem from './CheckBoxItem'

interface Props {
  pendingBlocks: UniqueTimeBlockData[]
  onSelectTimeBlock: (timeBlock: UniqueTimeBlockData, checked: boolean) => void
  timeSettingsCategoryById: Record<number, CustomTimeRangeCategory[]>
}

const CheckBoxForm = ({ pendingBlocks, timeSettingsCategoryById, onSelectTimeBlock }: Props) => {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
    >
      <>
        {pendingBlocks.map((block, index, array) => {
          return (
            <CheckBoxItem
              onSelectTimeBlock={onSelectTimeBlock}
              timeSettingsCategoryById={timeSettingsCategoryById}
              timeBlockData={block}
              key={index}
              isLast={index === array.length - 1}
            />
          )
        })}
      </>
    </Box>
  )
}

export default CheckBoxForm
